import StumbleGuysAlternative from './stumbleGuysAlternative'

export default StumbleGuysAlternative